import sysEnv from '@/env/envs'

import {
  mapStyleMap
} from './map_style'

export const pointChange = (point) => {
  let ggLng = point[0]
  let ggLat = point[1]
  let XPI = Math.PI * 3000.0 / 180.0
  let z = Math.sqrt(ggLng * ggLng + ggLat * ggLat) + 0.00002 * Math.sin(ggLat * XPI)
  let theta = Math.atan2(ggLat, ggLng) + 0.000003 * Math.cos(ggLng * XPI)
  let bdLng = z * Math.cos(theta) + 0.0065
  let bdLat = z * Math.sin(theta) + 0.006
  return [bdLng, bdLat]
}

// 行政区域边界信息获取 绘制只显示云南省 绘制具体的行政区域
export const xzqhLoadAndHz = function (bMap, xzqhList, hzConfig) {
  xzqhList.forEach((item) => {
    let bdary = new window.BMap.Boundary()
    bdary.get(item.name, function (rs) {
      if (item.name === '云南省') {
        mapXzOutBak(bMap, rs.boundaries, hzConfig)
      }
      let boundaries = rs.boundaries
      if (boundaries.length !== 0) {
        mapXzqhHz(bMap, item, boundaries, hzConfig)
      } else {
        console.log(item.name, '未获取到行政区划边界数据')
      }
    })
  })
}

export const getRotateByTwoPoint = function (point1, point2) {
  let data = 0
  if (!point1 || !point2) {
    return data
  }
  let zb = [point2[0] - point1[0], point2[1] - point1[1]]
  var a = Math.atan2(zb[1], zb[0])
  data = a * 180 / Math.PI
  if (data > 360) {
    data -= 360
  }
  if (data < 0) {
    data += 360
  }
  return data
}

export const updateMapCenterAndZoom = function (map, center, zoom) {
  map.centerAndZoom(new window.BMap.Point(center[0], center[1]), zoom)
}

// 行政区域绘制
const mapXzqhHz = function (map, area, boundaries, hzConfig) {
  let i = 0
  let plyList = []
  let pointArray = []
  let maxLat = 0
  let minLat = 1000
  let maxLng = 0
  let minLng = 1000
  while (i < boundaries.length) {
    let ply = new window.BMap.Polygon(boundaries[i], {
      strokeWeight: hzConfig.all.norm.strokeWeight,
      strokeColor: hzConfig.all.norm.strokeColor,
      fillOpacity: hzConfig.all.norm.fillOpacity,
      fillColor: hzConfig.all.norm.fillColor,
      strokeStyle: area.level === 'qx' ? 'dashed' : 'solid'
    })
    map.addOverlay(ply)
    ply.getPath().forEach((item) => {
      if (item.lat < minLat) {
        minLat = item.lat
      }
      if (item.lat > maxLat) {
        maxLat = item.lat
      }
      if (item.lng < minLng) {
        minLng = item.lng
      }
      if (item.lng > maxLng) {
        maxLng = item.lng
      }
    })
    plyList.push(ply)
    i += 1
  }
  pointArray = [new window.BMap.Point(maxLng, minLat), new window.BMap.Point(minLng, maxLat)]
  area.status = 1
  area.plyList = plyList
  area.pointArray = pointArray
}

export const setMapViewport = function (map, pointArray, options) {
  if (!map) {
    return
  }
  map.setViewport(pointArray, options || {
    delay: 100,
    enableAnimation: true
  })
}

// 只显示云南省
const mapXzOutBak = function (map, boundaries, hzConfig) {
  let points = ['180, -90', '180, 90', '-180, 90', '-180, -90', '180, -90']
  let boundariesList = boundaries[0].split(';')
  let boundarieList = [boundariesList[0]].concat(points)
  boundarieList.push(boundariesList[0])
  boundarieList = boundarieList.concat(boundariesList.slice(1, boundariesList.length))
  let boundarie = boundarieList.join(';')
  let ply = new window.BMap.Polygon(boundarie, {
    strokeWeight: hzConfig.out.strokeWeight,
    strokeOpacity: hzConfig.out.strokeOpacity,
    enableClicking: hzConfig.out.enableClicking,
    strokeColor: hzConfig.out.strokeColor,
    fillOpacity: hzConfig.out.fillOpacity,
    fillColor: hzConfig.out.fillColor
  })
  map.addOverlay(ply)
}

// echarts options
export const initOption = function ({tooltipF, legend, mapConfig, needBrush, visualMap}) {
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;'
    }
  }
  let legendData = []
  for (let key in legend) {
    legendData.push(key)
  }

  let styleJson = null
  if (mapConfig.dljc === true) {
    styleJson = null
  } else if (typeof mapConfig.dljc === 'object') {
    styleJson = mapConfig.dljc
  } else {
    styleJson = mapStyleMap
  }

  let option = {}
  option.animation = false
  option.bmap = {
    center: mapConfig ? mapConfig.ponit : [101.313408, 25.069329],
    zoom: mapConfig ? mapConfig.zoom : 7,
    roam: true,
    mapStyle: {
      styleJson
    }
  }
  if (needBrush) {
    option.toolbox = {
      left: 0,
      bottom: 0
    }
    option.brush = {
      outOfBrush: {
        color: '#abc'
      },
      transformable: false,
      brushStyle: {
        borderWidth: 2,
        color: 'rgba(0,0,0,0.2)',
        borderColor: 'rgba(0,0,0,0.5)'
      },
      throttleType: 'debounce',
      throttleDelay: 'debounce',
      geoIndex: 0
    }
  }
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 5,
    right: 5,
    data: legendData,
    selected: {},
    textStyle: {
      color: '#fff',
      fontSize: 12
    },
    itemWidth: 12,
    show: false
  }]
  for (let key in legend) {
    option.legend[0].selected[key] = legend[key]
  }
  option.tooltip = {
    trigger: 'item',
    position: function (point, params, dom, rect, size) {
      window.tooltipDom = dom
      let wkey = 'left'
      let hkey = 'top'
      let position = {}
      if (point[0] > size.viewSize[0] / 2) {
        wkey = 'right'
        position[wkey] = size.viewSize[0] - point[0]
      } else {
        position[wkey] = point[0]
      }
      if (point[1] > size.viewSize[1] / 2) {
        hkey = 'bottom'
        position[hkey] = size.viewSize[1] - point[1]
      } else {
        position[hkey] = point[1]
      }
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; ' + wkey + ': ' + (position[wkey] + 26) + 'px; ' + hkey + ': ' + (position[hkey] + 4) + 'px;'
      }, 200)
      return position
    },
    formatter: tooltipF
  }
  if (visualMap) {
    option.visualMap = visualMap
  }
  return option
}

let sealSizeNum = {
  '0': 4000,
  '92': 3000,
  '95': 1500,
  '98': 500,
  'total': 10000
}

export const shiZb = [{
  'area': '西双版纳傣族自治州',
  'cnpc': '0.5571',
  'snpc': '0.4429'
},
{
  'area': '楚雄彝族自治州',
  'cnpc': '0.5172',
  'snpc': '0.4828'
},
{
  'area': '丽江市',
  'cnpc': '0.4926',
  'snpc': '0.5074'
},
{
  'area': '保山市',
  'cnpc': '0.4878',
  'snpc': '0.5122'
},
{
  'area': '昭通市',
  'cnpc': '0.4387',
  'snpc': '0.5613'
},
{
  'area': '普洱市',
  'cnpc': '0.4251',
  'snpc': '0.5749'
},
{
  'area': '德宏傣族景颇族自治州',
  'cnpc': '0.4059',
  'snpc': '0.5941'
},
{
  'area': '迪庆藏族自治州',
  'cnpc': '0.3647',
  'snpc': '0.6353'
},
{
  'area': '文山壮族苗族自治州',
  'cnpc': '0.3429',
  'snpc': '0.6571'
},
{
  'area': '玉溪市',
  'cnpc': '0.3349',
  'snpc': '0.6651'
},
{
  'area': '昆明市',
  'cnpc': '0.3123',
  'snpc': '0.6877'
},
{
  'area': '红河哈尼族彝族自治州',
  'cnpc': '0.3096',
  'snpc': '0.6904'
},
{
  'area': '大理白族自治州',
  'cnpc': '0.3071',
  'snpc': '0.6929'
},
{
  'area': '临沧市',
  'cnpc': '0.2982',
  'snpc': '0.7018'
},
{
  'area': '曲靖市',
  'cnpc': '0.2473',
  'snpc': '0.7527'
}]

export const chartTooltipF = (parm) => {
  let str = ''
  let sData = parm.data
  let seriesId = parm.seriesId
  if (seriesId.includes('depot')) {
    str += sData.name
    let data = sData.data
    if (data.o0 || data.o92 || data.o95 || data.o98) {
      str += '<br/>油品'
      str += data.o0 ? ' 0#' : ''
      str += data.o92 ? ' 92#' : ''
      str += data.o95 ? ' 95#' : ''
      str += data.o98 ? ' 98#' : ''
    }
  } else if (seriesId.includes('gas')) {
    let data = sData.data
    // 合并点
    if (data.length && data.length > 0) {
      str = '加油站数量:  ' + data.length + '<br>'
      if (data.length < 5) {
        data.forEach((item, index) => {
          str += item.name + '<br>'
        })
      }
    } else {
      str += (data.name || '')
      if (data.isWarning) {
        str += '<br>' + data.isWarning
      } else {
        for (let key in data) {
          if (['0', '92', '95', '98', '柴油', '汽油'].includes(key)) {
            str += data[key].oil ? ('<br>' + ((data[key].oil) === '0' ? ' &nbsp 0' : data[key].oil) + '#') : ''
            str += data[key].sale ? ((' 8月日均销量: ' + data[key].day8sale) + '吨') : ''
            str += data[key].process ? ((' 8月日均销量同比: ' + ((Number(data[key].huanbi8) || 0) * 100).toFixed(0)) + '%') : ''
            str += data[key].oil ? ('<br>' + ((data[key].oil) === '0' ? ' &nbsp 0' : data[key].oil) + '#') : ''
            str += data[key].sale ? ((' 年度累计完成: ' + data[key].sale) + '吨') : ''
            str += data[key].process ? ((' 年计划完成进度: ' + ((Number(data[key].process) || 0) * 100).toFixed(0)) + '%') : ''
          }
        }
        if (data.zginfo) {
          str += ('<br>虚拟数据，谨慎参考 ')
          str += ('<br>整改项目名称: ' + data.zginfo.zgName)
          str += ('<br>整改开始时间: ' + data.zginfo.startDate)
          str += ('<br>已施工天数: ' + data.zginfo.workDays)
          str += ('<br>预计完工时间: ' + data.zginfo.overDay)
        }
      }
    }
  } else if (seriesId.includes('pipe')) {
    str = '管道: ' + sData.name
  } else if (seriesId.includes('railway')) {
    str = '铁路: ' + sData.name
  } else {
    str = seriesId + '--请处理'
  }
  return str
}

export const chartTooltipFfgs = (parm) => {
  let str = ''
  let sData = parm.data
  let seriesId = parm.seriesId
  if (seriesId.includes('depot')) {
    str += sData.name
    let data = sData.data
    if (data.o0 || data.o92 || data.o95 || data.o98) {
      str += '<br/>油品'
      str += data.o0 ? ' 0#' : ''
      str += data.o92 ? ' 92#' : ''
      str += data.o95 ? ' 95#' : ''
      str += data.o98 ? ' 98#' : ''
    }
  } else if (seriesId.includes('gas')) {
    let data = sData.data
    // 合并点
    if (data.length && data.length > 0) {
      str = '加油站数量:  ' + data.length + '<br>'
      if (data.length < 5) {
        data.forEach((item, index) => {
          str += item.name + '<br>'
        })
      }
    } else {
      str += (data.short_name || data.name || '')
      if (data.isWarning) {
        str += '<br>' + '预警：' + data.isWarning.emptyType
        str += '<br>' + '预警起始时间：' + (data.isWarning.startTime || '')
        str += '<br>' + data.isWarning.tankMark +
        '罐(' + data.isWarning.statusText + ')' +
        data.isWarning.oilNameJ + '  ' + data.isWarning.dealStatusText
        str += '<br>' + '库存：' + data.isWarning.oilVolume
        str += '<br>' + '安全小时：' + data.isWarning.emptyHour
      } else {
        let avgSale = null
        if (data.avg_sale !== null) {
          avgSale = Number(data.avg_sale)
          avgSale = isNaN(avgSale) ? null : avgSale
        }
        str += '<br> 日均销量: ' + (avgSale === null ? '__' : avgSale.toFixed(2) + '吨')
        let portion = null
        if (data.portion !== null) {
          portion = Number(data.portion)
          portion = isNaN(portion) ? null : portion
        }
        str += '<br> 份额: ' + (portion === null ? '__' : (portion * 100).toFixed(2) + '%')
      }
    }
  } else if (seriesId.includes('pipe')) {
    str = '管道: ' + sData.name
  } else if (seriesId.includes('railway')) {
    str = '铁路: ' + sData.name
  } else if (seriesId.includes('price_down')) {
    str = sData.data.name + '<br />'
    sData.data.preferential_details.forEach(v => {
      str += '<br />' + v.label + ':' + v.value
    })
  } else if (seriesId.includes('car_way')) {
    switch (parm.data.data.status) {
      case 'way':
        str = '在途轨迹'
        break
      case 'plan':
        str = '车辆轨迹'
        break
      case 'end':
        str = '历史轨迹'
        break
    }
  } else if (seriesId.includes('distribution_car')) {
    str = '' + parm.data.data.licenseNo
  } else if (['norm_way', 'residue_way', 'end_point', 'start_point'].includes(seriesId)) {
    str = parm.data.name
  } else {
    str = seriesId + '--请处理'
  }
  return str
}

export const chartTooltipDispatch = (parm) => {
  let str = ''
  let sData = parm.data
  let seriesId = parm.seriesId
  if (seriesId.includes('depot')) {
    str += sData.name
    let data = sData.data
    if (data.o0 || data.o92 || data.o95 || data.o98) {
      str += '<br/>油品'
      str += data.o0 ? ' 0#' : ''
      str += data.o92 ? ' 92#' : ''
      str += data.o95 ? ' 95#' : ''
      str += data.o98 ? ' 98#' : ''
    }
  } else if (seriesId.includes('gas')) {
    let data = sData.data
    // 合并点
    if (data.length && data.length > 0) {
      str = '加油站数量:  ' + data.length + '<br>'
      if (data.length < 5) {
        data.forEach((item, index) => {
          str += item.name + '<br>'
        })
      }
    } else {
      str += (data.short_name || data.name || '')
      if (data.isWarning) {
        str += '<br>' + '预警：' + data.isWarning.emptyType
        str += '<br>' + '预警起始时间：' + (data.isWarning.startTime || '')
        str += '<br>预警油罐：' + data.isWarning.tankMark +
        // '罐(' + data.isWarning.statusText + ')' +
        '罐' +
        '<br/>预警油品：' + data.isWarning.oilNameJ + '  ' + data.isWarning.dealStatusText
        str += '<br>' + '库存：' + data.isWarning.oilVolume + '升'
        // str += '<br>' + '安全小时：' + data.isWarning.emptyHour
      } else {
        let avgSale = null
        if (data.avg_sale !== null) {
          avgSale = Number(data.avg_sale)
          avgSale = isNaN(avgSale) ? null : avgSale
        }
        str += '<br> 日均销量: ' + (avgSale === null ? '__' : avgSale.toFixed(2) + '吨')
        let portion = null
        if (data.portion !== null) {
          portion = Number(data.portion)
          portion = isNaN(portion) ? null : portion
        }
        str += '<br> 份额: ' + (portion === null ? '__' : (portion * 100).toFixed(2) + '%')
      }
    }
  } else if (seriesId.includes('pipe')) {
    str = '管道: ' + sData.name
  } else if (seriesId.includes('railway')) {
    str = '铁路: ' + sData.name
  } else if (seriesId.includes('price_down')) {
    str = sData.data.name + '<br />'
    sData.data.preferential_details.forEach(v => {
      str += '<br />' + v.label + ':' + v.value
    })
  } else if (seriesId.includes('distribution_car')) {
    str = '车牌号:' + parm.data.data.car.licenseNo +
    '<br />准运油品:' + parm.data.data.car.gps.allowOilType

    if (parm.data.data.psd) {
      let planStatus = ''
      switch (parm.data.data.psd.status) {
        case 'way':
          planStatus = '在途'
          break
        case 'plan':
          planStatus = '计划'
          break
        case 'end':
          planStatus = '完成'
          break
      }
      str += '<br />当前配送状态:' + planStatus +
      '<br />装油油库:' + parm.data.data.psd.depotName +
      '<br />配送油站:' + parm.data.data.psd.gasName +
      // '<br />车仓数:' + parm.data.data.psd.tankMark +
      '<br />配送量:' + parm.data.data.psd.loadVolume + '升' +
      '<br />距离:' + parm.data.data.psd.distance + '公里'
    } else {
      str += '<br />无配送计划'
    }
  } else {
    str = parm.data.name
  }
  return str
}

export const chartTooltipMapDistribution = (parm) => {
  let str = ''
  if (parm.data && parm.data.name) {
    str += parm.data.name
  } else {
    str = null
  }
  return str
}

export const getScatterSize = (parm, zoom, oilType, volumeType) => {
  let size = 30
  let sData = parm.data
  if (parm.seriesId.includes('depot')) {
    size = 100 / (Number(sData.data.level) === 3 || !sData.data.level ? 1.3 : 1)
  } else if (parm.seriesId.includes('gas')) {
    let data = sData.data
    // 合并点
    if (data && data.length && data.length > 0) {
      size = data.length + 30
      size = size > 65 ? 65 : size
    } else {
      // 正常计算
      size = oilType === 'all' ? (data['size' + volumeType] || 0) : (data[String(oilType)] ? (data[String(oilType)]['size' + volumeType] || 0) : 0)
      // 预警站
      if (data.isWarning) {
        size = size * 3
      }
    }
  }
  return size * zoom / (zoom < 9 ? 25 : 15)
}

export const getScatterSizeFgs = (parm, zoom) => {
  let size = 30
  let sData = parm.data
  if (parm.seriesId.includes('depot')) {
    size = 100 / (Number(sData.data.level) === 3 || !sData.data.level ? 1.3 : 1)
  } else if (parm.seriesId.includes('gas')) {
    let data = sData.data
    // 合并点
    if (data && data.length && data.length > 0) {
      size = data.length + 30
      size = size > 65 ? 65 : size
    } else {
      // 正常计算
      size = 30
      // 预警站
      // if (data.isWarning) {
      //   size = size * 3
      // }
    }
  } else if (parm.seriesId.includes('distribution_car')) {
    size = 60
  }
  return size * zoom / (zoom < 9 ? 25 : 15)
}

let getSaleType = (sale) => {
  let saleType = null
  if (!sale || sale < 3000) {
    saleType = 'xy3'
  } else if (sale < 5000) {
    saleType = 'qj3z5'
  } else if (sale < 10000) {
    saleType = 'qj5z10'
  } else {
    saleType = 'dy10'
  }
  return saleType
}

let maxSize = 35
let minSize = 20

let getSizeFunSeal = (data, num) => {
  num = num || 1000
  let sale = Number(data) || 0
  let size = ((sale / num) > 1 ? 1 : (sale / num)) * maxSize
  return size > minSize ? size : minSize
}

let getSizeFunProcess = (data) => {
  let num = 2
  let processD = Number(data.process) || 0
  let size = ((processD / num) > 1 ? 1 : (processD / num)) * maxSize
  return size > minSize ? size : minSize
}

export const convertDataFgs = (data) => {
  let newData = []
  data.forEach((item, index) => {
    // 销量吨级计算
    let level = item.avgSale * 365
    let saleLevel = ''
    if (level < 3000) {
      saleLevel = '三千以下'
    } else if (level > 3000 && level < 5000) {
      saleLevel = '三千'
    } else if (level > 5000 && level < 7000) {
      saleLevel = '五千'
    } else if (level > 7000 && level < 10000) {
      saleLevel = '七千'
    } else {
      saleLevel = '万'
    }

    let dataItem = {
      id: item.id,
      name: item.name,
      short_name: item.short_name,
      adr: item.address,
      group: item.type,
      gasType: item.tag,
      point: [item.lng, item.lat],
      cmp: item.company,
      oil: item.oil,
      area: item.area,
      areaQx: item.district,
      avg_sale: item.avgSale,
      portion: item.portion,
      create_time: item.create_time,
      remould: item.remould,
      property: item.property,
      collection: item.collection,
      road: item.road,
      label: item.label,
      code: item.code,
      preferential_type: item.preferential_type,
      preferential_details: item.preferential_type > 0 && item.preferential_details ? JSON.parse(item.preferential_details) : null,
      sale_level: saleLevel,
      tonLevel: item.tonLevel
    }
    newData.push(dataItem)
  })
  let newDataMap = {}
  newData.forEach((item, index) => {
    let key = item.name
    if (typeof newDataMap[key] === 'undefined') {
      newDataMap[key] = {
        id: item.id,
        name: item['name'],
        short_name: item.short_name,
        adr: item.adr,
        group: item.group,
        gasType: item['gasType'],
        point: item.point,
        cmp: item.cmp,
        area: item.area,
        areaQx: item.areaQx,
        oilNum: 0,
        avg_sale: item.avg_sale,
        portion: item.portion,
        create_time: item.create_time,
        remould: item.remould,
        property: item.property,
        collection: item.collection,
        road: item.road,
        label: item.label,
        code: item.code,
        sale_level: item.sale_level,
        preferential_type: item.preferential_type,
        preferential_details: item.preferential_details,
        tonLevel: item.tonLevel
      }
    }
    if (item.oil) {
      newDataMap[key][item.oil] = {
        oil: item.oil
      }
      newDataMap[key].oilNum += 1
    }
  })
  let newData2 = []
  for (let key in newDataMap) {
    // newDataMap[key].saleType = getSaleType(newDataMap[key].totalSale)
    newData2.push(newDataMap[key])
  }
  return Object.freeze(newData2)
}

export const getRouterPointsByBmap = (bMap, startPonit, endPonit) => {
  return new Promise((resolve) => {
    let mapSearch = new window.BMap.DrivingRoute(bMap, {
      onSearchComplete: function (data) {
        let pathList = []
        if (data.getNumPlans() > 0) {
          let routePlan = data.getPlan(0)
          if (routePlan.getNumRoutes() > 0) {
            pathList = routePlan.getRoute(0).getPath()
          }
        }
        let routes = []
        pathList.forEach((item) => {
          routes.push([item.lng, item.lat])
        })
        resolve(routes)
      }
    })
    mapSearch.search(startPonit, endPonit)
  })
}

export const convertData = (data) => {
  let newData = []
  data.forEach((item, index) => {
    let dataItem = {
      id: item.id,
      name: item.name,
      adr: item.address,
      group: item.type,
      gasType: item.tag,
      point: [item.lng, item.lat],
      cmp: item.company,
      oil: item.oil,
      sale17: item.sale2017 || 0,
      sale: item.sale2018 || 0,
      plan: item.plan || 0,
      process: item.process || 0,
      area: item.area,
      areaQx: item.district,
      avg_sale: item.avg_sale,
      portion: item.portion
    }
    dataItem['day8sale'] = dataItem.sale ? (Number(dataItem.sale) / 8 / 30).toFixed(2) : 0
    dataItem['day8sale17'] = dataItem.sale17 ? (Number(dataItem.sale17) / 365).toFixed(2) : 0
    dataItem['huanbi8'] = dataItem.day8sale17 ? (Number(dataItem.day8sale) / Number(dataItem.day8sale17)).toFixed(2) : 0
    dataItem['sizesale'] = getSizeFunSeal(dataItem.sale, sealSizeNum[dataItem.oil])
    dataItem['sizeprocess'] = getSizeFunProcess(dataItem)
    newData.push(dataItem)
  })
  let newDataMap = {}
  newData.forEach((item, index) => {
    let key = item.name
    if (typeof newDataMap[key] === 'undefined') {
      newDataMap[key] = {
        id: item.id,
        name: item['name'],
        adr: item.adr,
        group: item.group,
        gasType: item.gasType,
        point: item.point,
        cmp: item.cmp,
        area: item.area,
        areaQx: item.areaQx,
        sizesale: 0,
        sizeprocess: 0,
        oilNum: 0,
        totalSale: 0,
        totalSale17: 0,
        avg_sale: item.avg_sale,
        portion: item.portion
      }
      // if (newDataMap[key].name === '云南销售昆明分公司干坝塘加油站') {
      //   newDataMap[key].isWarning = '预警类型: 设备工况报警<br>具体情况: 液位仪故障'
      // }
      // if (newDataMap[key].name === '云南销售红河分公司异龙湖加油站2站') {
      //   newDataMap[key].isWarning = '预警类型: 安全运行预警<br>具体情况: 1号罐 0号车用柴油即将过期<br>已销售: 79天<br>保质期: 90天'
      // }
      // if (newDataMap[key].name === '云南销售曲靖分公司曲靖福宝加油站') {
      //   newDataMap[key].isWarning = '预警类型: 安全运行预警<br>具体情况: 3号罐 98号车用汽油即将过期<br>已销售: 83天<br>保质期: 90天'
      // }
      // if (newDataMap[key].name === '普洱分公司中原加油站二站') {
      //   newDataMap[key].isWarning = '预警类型: 库存预警<br>具体情况: 0号柴油存在断油风险<br>当前库存量：30142升<br>今日预测销量：49500升 运距339公里<br>在途情况：无在途'
      // }
      // if (newDataMap[key].name === '云南销售大理分公司顺达加油站') {
      //   newDataMap[key].isWarning = '预警类型: 库存预警<br>具体情况: 0号柴油存在断油风险<br>当前库存量：8783升<br>今日预测销量：77415升 运距6公里<br>在途情况：无在途'
      // }
      if (newDataMap[key].name === '云南销售昆明分公司明波加油站1站') {
        newDataMap[key].isWarning = '预警类型: 库存预警'
      }
    }
    if (item.oil) {
      newDataMap[key][item.oil] = {
        oil: item.oil,
        sale17: item.sale17.toFixed(0),
        plan: item.plan,
        sale: item.sale,
        daySale: (Number(item.sale) / 12).toFixed(2),
        process: item.process,
        sizesale: item.sizesale,
        sizeprocess: item.sizeprocess,
        day8sale: item['day8sale'],
        huanbi8: item['huanbi8']
      }
      newDataMap[key].oilNum += 1
      newDataMap[key].sizeprocess += newDataMap[key][item.oil].sizeprocess
      newDataMap[key].totalSale += Number(newDataMap[key][item.oil].sale) || 0
      newDataMap[key].totalSale17 += Number(newDataMap[key][item.oil].sale17) || 0
    }
  })
  let newData2 = []
  for (let key in newDataMap) {
    newDataMap[key].sizeprocess = newDataMap[key].oilNum > 0 ? (newDataMap[key].sizeprocess / newDataMap[key].oilNum) : minSize
    newDataMap[key].sizesale = getSizeFunSeal(newDataMap[key].totalSale, sealSizeNum['total'])
    newDataMap[key].saleType = getSaleType(newDataMap[key].totalSale)
    newData2.push(newDataMap[key])
    if (!newDataMap[key]['汽油'] && !newDataMap[key]['柴油'] && !newDataMap[key]['0'] && !newDataMap[key]['92'] && !newDataMap[key]['95'] && !newDataMap[key]['98']) {
      newDataMap[key].zginfo = {
        zgName: '双层罐整改',
        startDate: '2018-08-17',
        workDays: 27,
        overDay: '18天'
      }
    }
  }
  return newData2
}

export const fCompanys = ['昆明分公司', '楚雄分公司', '普洱分公司', '曲靖分公司', '玉溪分公司', '红河分公司', '文山分公司', '丽江分公司', '昭通分公司', '保山分公司', '临沧分公司', '德宏分公司', '版纳分公司', '大理分公司', '迪庆分公司']

export const getSelectData = function (dataList) {
  let data = []
  dataList.forEach((item) => {
    data.push({
      key: item,
      label: item
    })
  })
  return data
}

export const gasTypes = [{
  label: '全部类型',
  key: 'all'
},
{
  label: '高速站',
  key: '高速站'
},
{
  label: '国道站',
  key: '国道站'
},
{
  label: '省道站',
  key: '省道站'
},
{
  label: '县级站',
  key: '县级站'
},
{
  label: '城区站',
  key: '城区站'
},
{
  label: '农村站',
  key: '农村站'
}]

export const saleTypes = [{
  key: 'dy10',
  label: '一类(10000吨以上)'
},
{
  key: 'qj5z10',
  label: '二类(5000～10000吨)'
},
{
  key: 'qj3z5',
  label: '三类(3000～5000吨)'
},
{
  key: 'xy3',
  label: '低销(3000吨以下)'
}]

export const oilTypes = [{
  label: '全部油品',
  key: 'all'
},
{
  label: '0号 车用柴油(Ⅵ)',
  key: '0'
},
{
  label: '92号 车用汽油(ⅥA)',
  key: '92'
},
{
  label: '95号 车用汽油(ⅥA)',
  key: '95'
},
{
  label: '98号 车用汽油(ⅥA)',
  key: '98'
}]

let adr = window.location.host

export const getChartSeries = function (seriesData, getSizeFun, showLabel) {
  showLabel = showLabel || false
  let defFun = (data) => {
    return 8
  }
  getSizeFun = getSizeFun || defFun
  let series = [
    {
      id: 'gas_zsy_warning',
      type: 'effectScatter',
      name: sysEnv.zsyName + '预警',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      rippleEffect: {
        period: 2,
        scale: 5
      },
      data: seriesData['gas_zsy_warning'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#ea0000'
        }
      },
      z: 5
    },
    {
      id: 'gas_zsy_warning_i',
      name: sysEnv.zsyName + '预警',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/logo_zsy.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['gas_zsy_warning_i'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#666'
        }
      },
      z: 6
    },
    {
      id: 'gas_zsh',
      name: '中石化',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/logo_zsh.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['gas_zsh'] || [],
      label: {
        normal: {
          position: 'top',
          show: showLabel,
          formatter: '{b}',
          backgroundColor: '#fff',
          padding: 3,
          borderRadius: 1
        }
      },
      itemStyle: {
        normal: {
          color: '#666'
        }
      },
      z: 3
    },
    {
      id: 'gas_zy',
      name: '社会站',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/logo_ql.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['gas_zy'] || [],
      label: {
        normal: {
          position: 'top',
          show: showLabel,
          formatter: '{b}',
          backgroundColor: '#fff',
          padding: 3,
          borderRadius: 1
        }
      },
      itemStyle: {
        normal: {
          color: '#5998fe'
        }
      },
      z: 2
    },
    {
      id: 'gas_zsy',
      type: 'scatter',
      name: sysEnv.zsyName,
      symbol: 'image://http://' + adr + '/static/logo_zsy.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['gas_zsy'] || [],
      label: {
        normal: {
          position: 'top',
          show: showLabel,
          formatter: '{b}',
          backgroundColor: '#fff',
          padding: 3,
          borderRadius: 1
        }
      },
      itemStyle: {
        normal: {
          color: '#ed8503'
        }
      },
      z: 4
    },
    {
      id: 'depot_zsy_gd',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_zsy_1.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_zsy_gd'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'depot_zsy_tl',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_zsy_2.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_zsy_tl'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'depot_zsy_df',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_zsy_3.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_zsy_df'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 6
    },
    {
      id: 'depot_zsh',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_zsh.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_zsh'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'depot_gc',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_other.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_gc'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'depot_zhy',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_other.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_zhy'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'depot_sh',
      name: '油库',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/youku_other.png',
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['depot_sh'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 5
    },
    {
      id: 'pipe_zsy',
      name: '管道',
      type: 'lines',
      polyline: true,
      coordinateSystem: 'bmap',
      data: seriesData['pipe_zsy'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#cd3019',
          width: 3,
          opacity: 1
          // ,curveness: 0.08
        },
        emphasis: {
          color: '#cd3019',
          width: 3,
          opacity: 1
        }
      },
      z: 3
    },
    {
      id: 'pipe_zsh',
      name: '管道',
      type: 'lines',
      polyline: true,
      coordinateSystem: 'bmap',
      data: seriesData['pipe_zsh'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#00a7ff',
          width: 3,
          opacity: 1
          // ,curveness: 0.08
        },
        emphasis: {
          color: '#00a7ff',
          width: 3,
          opacity: 1
        }
      }
    },
    {
      id: 'railway',
      name: '铁路',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['railway'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 8,
        period: 20,
        color: '#666',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#000',
          type: 'dashed',
          width: 2,
          opacity: 0.8
        },
        emphasis: {
          color: '#000',
          type: 'dashed',
          width: 2,
          opacity: 0.8
        }
      },
      z: 3
    },
    {
      id: 'railway_d',
      name: '铁路',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['railway'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 8,
        period: 20,
        color: '#666',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#000',
          width: 3,
          opacity: 0.8
        },
        emphasis: {
          color: '#000',
          width: 3,
          opacity: 0.8
        }
      },
      z: 1
    },
    {
      id: 'railway_bak',
      name: '铁路',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['railway'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#ffffff',
          width: 2,
          opacity: 1
        },
        emphasis: {
          color: '#ffffff',
          width: 2,
          opacity: 1
        }
      },
      z: 2
    },
    {
      id: 'norm_way',
      name: '预计路线',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['norm_way'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#808695',
          width: 3,
          opacity: 1
        },
        emphasis: {
          color: '#808695',
          width: 3,
          opacity: 1
        }
      },
      z: 2
    },
    {
      id: 'residue_way',
      name: '在途剩余路线',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['residue_way'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#67cf94',
          width: 3,
          opacity: 1
        },
        emphasis: {
          color: '#67cf94',
          width: 3,
          opacity: 1
        }
      },
      z: 10
    },
    {
      id: 'car_way', // 在途
      name: '车辆轨迹',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['car_way'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#3f7ff4',
          width: 3,
          opacity: 1
        },
        emphasis: {
          color: '#3f7ff4',
          width: 3,
          opacity: 1
        }
      },
      z: 10
    },
    {
      id: 'car_way_done',
      name: '车辆轨迹',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['car_way_done'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#67cf94',
          width: 4,
          opacity: 1
        },
        emphasis: {
          color: '#67cf94',
          width: 4,
          opacity: 1
        }
      },
      z: 1
    },
    {
      id: 'lines_way',
      name: '选中的轨迹',
      type: 'lines',
      polyline: true,
      large: true,
      coordinateSystem: 'bmap',
      data: seriesData['lines_way'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      lineStyle: {
        normal: {
          color: '#ff9900',
          width: 6,
          opacity: 1
        },
        emphasis: {
          color: '#ff9900',
          width: 6,
          opacity: 1
        }
      },
      z: 2
    },
    {
      id: 'play_car_going',
      name: '配送车辆',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/car.png',
      coordinateSystem: 'bmap',
      symbolSize: 45,
      symbolKeepAspect: true,
      data: seriesData['play_car_going'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 7
    },
    {
      id: 'play_car_stop',
      name: '配送车辆',
      type: 'effectScatter',
      effectType: 'ripple',
      rippleEffect: {
        period: 2,
        scale: 2
      },
      symbol: 'image://http://' + adr + '/static/car.png',
      coordinateSystem: 'bmap',
      symbolSize: 45,
      symbolKeepAspect: true,
      data: seriesData['play_car_stop'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 7
    },
    {
      id: 'distribution_car',
      name: '配送车辆',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/car.png',
      coordinateSystem: 'bmap',
      symbolSize: 45,
      symbolKeepAspect: true,
      data: seriesData['distribution_car'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#345baa',
          opacity: 1
        }
      },
      z: 7
    },
    {
      id: 'price_down',
      name: '价格下调',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/green_arrow.png',
      symbolRotate: 0,
      symbolOffset: [0, '-100%'],
      coordinateSystem: 'bmap',
      symbolSize: (data, data2) => {
        return getSizeFun(data2)
      },
      data: seriesData['price_down'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      itemStyle: {
        normal: {
          color: '#666'
        }
      },
      z: 1
    },
    {
      id: 'distribution_plan',
      name: '配送计划',
      type: 'lines',
      polyline: false,
      coordinateSystem: 'bmap',
      data: seriesData['distribution_plan'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 6,
        period: 20,
        color: '#d79e40',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#464c5b',
          width: 1,
          opacity: 1,
          curveness: 0.1
        },
        emphasis: {
          color: '#464c5b',
          width: 1,
          opacity: 1,
          curveness: 0.1
        }
      }
    },
    {
      id: 'distribution_plan_way',
      name: '在途的配送计划',
      type: 'lines',
      polyline: false,
      coordinateSystem: 'bmap',
      data: seriesData['distribution_plan_way'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 6,
        period: 20,
        color: '#d79e40',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#f39700',
          width: 1,
          opacity: 1,
          curveness: 0.1
        },
        emphasis: {
          color: '#f39700',
          width: 1,
          opacity: 1,
          curveness: 0.1
        }
      }
    },
    {
      id: 'distribution_plan_end',
      name: '完成的配送计划',
      type: 'lines',
      polyline: false,
      coordinateSystem: 'bmap',
      data: seriesData['distribution_plan_end'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 6,
        period: 20,
        color: '#d79e40',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#00cc66',
          width: 1,
          opacity: 1,
          curveness: 0.1
        },
        emphasis: {
          color: '#00cc66',
          width: 1,
          opacity: 1,
          curveness: 0.1
        }
      }
    },
    {
      id: 'distribution_plan_plan',
      name: '计划中的配送',
      type: 'lines',
      polyline: false,
      coordinateSystem: 'bmap',
      data: seriesData['distribution_plan_plan'] || [],
      label: {
        normal: {
          position: 'right',
          show: false
        }
      },
      effect: {
        show: true,
        symbolSize: 6,
        period: 20,
        color: '#d79e40',
        trailLength: 0
      },
      lineStyle: {
        normal: {
          color: '#3399ff',
          width: 1,
          opacity: 1,
          curveness: 0.1
        },
        emphasis: {
          color: '#3399ff',
          width: 1,
          opacity: 1,
          curveness: 0.1
        }
      }
    },
    {
      id: 'start_point',
      name: '标记',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/point-start.png',
      coordinateSystem: 'bmap',
      symbolSize: 35,
      symbolOffset: [0, '-80%'],
      data: seriesData['start_point'] || [],
      z: 13
    },
    {
      id: 'end_point',
      name: '标记',
      type: 'scatter',
      symbol: 'image://http://' + adr + '/static/point-end.png',
      coordinateSystem: 'bmap',
      symbolSize: 35,
      symbolOffset: [0, '-80%'],
      data: seriesData['end_point'] || [],
      z: 13
    }
  ]

  return series
}

export const addEvent = function (chart, event, dealFun) {
  chart.on(event, function (params) {
    dealFun(params)
  })
}

export const getLabelName = (label) => {
  let names = [
    {label: '旗舰型', key: 1},
    {label: '竞争型', key: 2},
    {label: '潜力型', key: 3},
    {label: '专业型', key: 4},
    {label: '其他', key: 0}
  ]
  if (label === false) {
    return names
  } else {
    let name = names.find(v => v.key === label)
    return name ? name.label : '其他'
  }
}

export const getPropertyName = (property) => {
  let names = [
    {label: '委托经营', key: 1},
    {label: '控股', key: 2},
    {label: '租赁', key: 3},
    {label: '全资', key: 4},
    {label: '其他', key: 0}
  ]
  if (property === false) {
    return names
  } else {
    let name = names.find(v => v.key === property)
    return name ? name.label : '其他'
  }
}

export const getPreferentialTypeName = (type) => {
  switch (type) {
    case 1:
      return '点对点'
    case 2:
      return '平滑'
    case 3:
      return '系统优惠'
    case 4:
      return '开业优惠'
    case 5:
      return '时点优惠'
    case 6:
      return '以站代库'
    default:
      return '无优惠'
  }
}

export const getPreferentialType = () => {
  return [
    {key: 1, label: '点对点'},
    {key: 2, label: '平滑'},
    {key: 3, label: '系统优惠'},
    {key: 4, label: '开业优惠'},
    {key: 5, label: '时点优惠'},
    {key: 6, label: '以站代库'}
  ]
}

export const getPreferentialFields = (type) => {
  let fields = []
  switch (type) {
    case 1: // 点对点
      fields = [
        {label: '每升最大让价空间'},
        {label: '到位价'},
        {label: '目前优惠（默认0#优惠）'},
        {label: '优惠后挂牌'},
        {label: '备注'}
      ]
      break
    case 2: // 平滑
      fields = [
        {label: '政策'},
        {label: '92#'},
        {label: '95#'},
        {label: '0#'},
        {label: '调整情况'}
      ]
      break
    case 3: // 系统优惠
      fields = [
        {label: '目前优惠（默认0#优惠）'},
        {label: '调整情况'}
      ]
      break
    case 4: // 开业优惠
      fields = [
        {label: '政策'},
        {label: '执行日期'},
        {label: '备注'}
      ]
      break
    case 5: // 时点优惠
      fields = [
        {label: '92#'},
        {label: '95#'},
        {label: '98#'},
        {label: '0#'},
        {label: '系统优惠'},
        {label: '备注'}
      ]
      break
    case 6: // 以站代库
      fields = [
        {label: '调整后价格单枪低挂（部分站点系统优惠）'},
        {label: '到位价'},
        {label: '优惠后价格'},
        {label: '其他'},
        {label: '说明'},
        {label: '优惠幅度'},
        {label: '目前单号'},
        {label: '到期时间'},
        {label: '以站代库价格到位率'}
      ]
      break
  }

  return fields
}



// WEBPACK FOOTER //
// ./src/cllib/mapToolsNew.js